<!-- @format -->

<ng-container *transloco="let t">
  @if (downloadableSignatureRequestId$ | async; as signatureRequestId) {
    <fudis-button
      [label]="t('PROFILE.ATTAINMENT.DEGREE_CERTIFICATE_DOWNLOAD')"
      (handleClick)="downloadSignedDegreeCertificate(signatureRequestId)" />
  }
</ng-container>
